import React, { createContext, useState, useCallback, useContext } from 'react';
import { Cookies } from 'react-cookie';
import i18n from '~/localization';

interface LanguageContextData {
  language: string;
  changeLanguage(language: string): void;
}

const LanguageContext = createContext<LanguageContextData>(
  {} as LanguageContextData,
);

const cookies = new Cookies();

export const LanguageProvider: React.FC = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const lang = cookies.get(`@${process.env.REACT_APP_APP_NAME}:language`);
    if (lang) {
      i18n.changeLanguage(lang);
    }
    return lang || 'ptBr';
  });

  const changeLanguage = useCallback((lang: string) => {
    setLanguage(lang);
    cookies.set(`@${process.env.REACT_APP_APP_NAME}:language`, lang);
    i18n.changeLanguage(lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export function useLanguage(): LanguageContextData {
  const context = useContext(LanguageContext);
  return context;
}
